import { Order } from 'protocol/api/billing_new/dto_order_new_pb';

// Billed.Amount is what was invoiced; the list price stays in the product snapshot.
export const getOrderListPrice = (order: Order): string | undefined => {
  const effect = order.Effect?.Effect;

  switch (effect?.case) {
    case 'SubscriptionAdd':
      return effect.value.Subscription?.Price;
    case 'PackageAdd':
      return effect.value.Package?.Price;
    case 'DiagnocoinPurchase':
      return effect.value.Product?.Price;
    default:
      return undefined;
  }
};
